export function scrollLeft(offset, calcs) {
    let t = offset + (calcs.step * calcs.multiplier);
    return t > 0 ? 0 : t;
}
//# sourceMappingURL=scrollLeft.js.map